module.exports = __webpack_public_path__ + "static/media/wind-mill-orange.9b3534ad.svg";